// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import ContactResourceViewModel from '../../../../viewModel/resource/ContactResourceViewModel';
import MemberBusinessAddressResourceViewModel from '../../../../viewModel/resource/MemberBusinessAddressResourceViewModel';
import CorrespondenceAddressResourceViewModel from '../../../../viewModel/resource/CorrespondenceAddressResourceViewModel';
import MembershipBusinessResourceViewModel from '../../../../viewModel/resource/MembershipBusinessResourceViewModel';
import BasketResourceViewModel from '../../../../viewModel/resource/BasketResourceViewModel';
import RequestSummaryResourceViewModel from '../../../../viewModel/resource/RequestSummaryResourceViewModel';
import CreateMembershipRequestViewModel from '../../../../viewModel/resource/CreateMembershipRequestViewModel';
import CreateMembershipRequestDTO from '../../dto/resource/CreateMembershipRequestDTO';

export default abstract class CreateMembershipRequestModel extends BaseModel<CreateMembershipRequestDTO> {
  /**
  * @type {int64}
  */
  get userId() { return this.dto.userId; }
  set userId(value) { this.dto.userId = value; }
  /**
  * @type {uuid}
  */
  get businessUnitId() { return this.dto.businessUnitId; }
  set businessUnitId(value) { this.dto.businessUnitId = value; }
  /**
  * @type {uuid}
  */
  get payrollCategoryId() { return this.dto.payrollCategoryId; }
  set payrollCategoryId(value) { this.dto.payrollCategoryId = value; }
  /**
  * @type {int32}
  */
  get payrollCategoryKey() { return this.dto.payrollCategoryKey; }
  set payrollCategoryKey(value) { this.dto.payrollCategoryKey = value; }
  /**
  */
  get isMembershipReEntry() { return this.dto.isMembershipReEntry; }
  set isMembershipReEntry(value) { this.dto.isMembershipReEntry = value; }
  /**
  * @type {date-time}
  */
  get entryDate() { return this.dto.entryDate; }
  set entryDate(value) { this.dto.entryDate = value; }
  /**
  * @type {uuid}
  */
  get socialInsuranceId() { return this.dto.socialInsuranceId; }
  set socialInsuranceId(value) { this.dto.socialInsuranceId = value; }
  /**
  */
  get hasOperatingLicence() { return this.dto.hasOperatingLicence; }
  set hasOperatingLicence(value) { this.dto.hasOperatingLicence = value; }
  /**
  */
  get operatingLicenceOwner() { return this.dto.operatingLicenceOwner; }
  set operatingLicenceOwner(value) { this.dto.operatingLicenceOwner = value; }
  /**
  * @type {date-time}
  */
  get dateOperatingLicenceIssued() { return this.dto.dateOperatingLicenceIssued; }
  set dateOperatingLicenceIssued(value) { this.dto.dateOperatingLicenceIssued = value; }
  /**
  */
  get hasCertificateOfProficiency() { return this.dto.hasCertificateOfProficiency; }
  set hasCertificateOfProficiency(value) { this.dto.hasCertificateOfProficiency = value; }
  /**
  * @type {date-time}
  */
  get dateCertificateOfProficiencyIssued() { return this.dto.dateCertificateOfProficiencyIssued; }
  set dateCertificateOfProficiencyIssued(value) { this.dto.dateCertificateOfProficiencyIssued = value; }
  /**
  * @type {int64}
  */
  get certificateOfProficiencyCantonId() { return this.dto.certificateOfProficiencyCantonId; }
  set certificateOfProficiencyCantonId(value) { this.dto.certificateOfProficiencyCantonId = value; }
  /**
  */
  get certificateOfProficiencyCourse() { return this.dto.certificateOfProficiencyCourse; }
  set certificateOfProficiencyCourse(value) { this.dto.certificateOfProficiencyCourse = value; }
  /**
  */
  get isMemberContactReadonly() { return this.dto.isMemberContactReadonly; }
  set isMemberContactReadonly(value) { this.dto.isMemberContactReadonly = value; }
  /**
  */
  get memberContact() { return this.getObjectModel(() => this.dto.memberContact, ContactResourceViewModel)!; }
  set memberContact(value) { this.setObjectModel(() => this.dto.memberContact, value); }
  /**
  */
  get isMemberBusinessContactReadonly() { return this.dto.isMemberBusinessContactReadonly; }
  set isMemberBusinessContactReadonly(value) { this.dto.isMemberBusinessContactReadonly = value; }
  /**
  */
  get memberBusinessContact() { return this.getObjectModel(() => this.dto.memberBusinessContact, MemberBusinessAddressResourceViewModel)!; }
  set memberBusinessContact(value) { this.setObjectModel(() => this.dto.memberBusinessContact, value); }
  /**
  */
  get isMemberCorrespondeceContactReadonly() { return this.dto.isMemberCorrespondeceContactReadonly; }
  set isMemberCorrespondeceContactReadonly(value) { this.dto.isMemberCorrespondeceContactReadonly = value; }
  /**
  */
  get memberCorrespondenceContact() { return this.getObjectModel(() => this.dto.memberCorrespondenceContact, CorrespondenceAddressResourceViewModel)!; }
  set memberCorrespondenceContact(value) { this.setObjectModel(() => this.dto.memberCorrespondenceContact, value); }
  /**
  */
  get isMembershipBusinessReadonly() { return this.dto.isMembershipBusinessReadonly; }
  set isMembershipBusinessReadonly(value) { this.dto.isMembershipBusinessReadonly = value; }
  /**
  */
  get membershipBusiness() { return this.getObjectModel(() => this.dto.membershipBusiness, MembershipBusinessResourceViewModel)!; }
  set membershipBusiness(value) { this.setObjectModel(() => this.dto.membershipBusiness, value); }
  /**
  */
  get orderBasket() { return this.getObjectModel(() => this.dto.orderBasket, BasketResourceViewModel)!; }
  set orderBasket(value) { this.setObjectModel(() => this.dto.orderBasket, value); }
  /**
  */
  get summary() { return this.getObjectModel(() => this.dto.summary, RequestSummaryResourceViewModel)!; }
  set summary(value) { this.setObjectModel(() => this.dto.summary, value); }
  /**
  */
  get acceptIsRelatedToGastro() { return this.dto.acceptIsRelatedToGastro; }
  set acceptIsRelatedToGastro(value) { this.dto.acceptIsRelatedToGastro = value; }
  /**
  */
  get acceptGsoc() { return this.dto.acceptGsoc; }
  set acceptGsoc(value) { this.dto.acceptGsoc = value; }
  /**
  */
  get acceptAgb() { return this.dto.acceptAgb; }
  set acceptAgb(value) { this.dto.acceptAgb = value; }
  /**
  */
  get acceptFilledOutTruthful() { return this.dto.acceptFilledOutTruthful; }
  set acceptFilledOutTruthful(value) { this.dto.acceptFilledOutTruthful = value; }
  /**
  */
  get acceptGsStatutes() { return this.dto.acceptGsStatutes; }
  set acceptGsStatutes(value) { this.dto.acceptGsStatutes = value; }
  /**
  */
  get newsletter() { return this.dto.newsletter; }
  set newsletter(value) { this.dto.newsletter = value; }
  /**
  */
  get acceptGdpr() { return this.dto.acceptGdpr; }
  set acceptGdpr(value) { this.dto.acceptGdpr = value; }
  /**
  */
  get acceptContactForClassification() { return this.dto.acceptContactForClassification; }
  set acceptContactForClassification(value) { this.dto.acceptContactForClassification = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    value = Number.parseFloat(qs.userid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.userId = value;
    this.dto.businessUnitId = qs.businessunitid;
    this.dto.payrollCategoryId = qs.payrollcategoryid;
    value = Number.parseFloat(qs.payrollcategorykey);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.payrollCategoryKey = value;
    value = qs.isMembershipReEntry === 'true' ? true : qs.ismembershipreentry;
    value = qs.isMembershipReEntry === 'false' ? false : undefined;
    this.dto.isMembershipReEntry = value;
    this.dto.entryDate = qs.entrydate;
    this.dto.socialInsuranceId = qs.socialinsuranceid;
    value = qs.hasOperatingLicence === 'true' ? true : qs.hasoperatinglicence;
    value = qs.hasOperatingLicence === 'false' ? false : undefined;
    this.dto.hasOperatingLicence = value;
    this.dto.operatingLicenceOwner = qs.operatinglicenceowner;
    this.dto.dateOperatingLicenceIssued = qs.dateoperatinglicenceissued;
    value = qs.hasCertificateOfProficiency === 'true' ? true : qs.hascertificateofproficiency;
    value = qs.hasCertificateOfProficiency === 'false' ? false : undefined;
    this.dto.hasCertificateOfProficiency = value;
    this.dto.dateCertificateOfProficiencyIssued = qs.datecertificateofproficiencyissued;
    value = Number.parseFloat(qs.certificateofproficiencycantonid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.certificateOfProficiencyCantonId = value;
    this.dto.certificateOfProficiencyCourse = qs.certificateofproficiencycourse;
    value = qs.isMemberContactReadonly === 'true' ? true : qs.ismembercontactreadonly;
    value = qs.isMemberContactReadonly === 'false' ? false : undefined;
    this.dto.isMemberContactReadonly = value;
    value = qs.isMemberBusinessContactReadonly === 'true' ? true : qs.ismemberbusinesscontactreadonly;
    value = qs.isMemberBusinessContactReadonly === 'false' ? false : undefined;
    this.dto.isMemberBusinessContactReadonly = value;
    value = qs.isMemberCorrespondeceContactReadonly === 'true' ? true : qs.ismembercorrespondececontactreadonly;
    value = qs.isMemberCorrespondeceContactReadonly === 'false' ? false : undefined;
    this.dto.isMemberCorrespondeceContactReadonly = value;
    value = qs.isMembershipBusinessReadonly === 'true' ? true : qs.ismembershipbusinessreadonly;
    value = qs.isMembershipBusinessReadonly === 'false' ? false : undefined;
    this.dto.isMembershipBusinessReadonly = value;
    value = qs.acceptIsRelatedToGastro === 'true' ? true : qs.acceptisrelatedtogastro;
    value = qs.acceptIsRelatedToGastro === 'false' ? false : undefined;
    this.dto.acceptIsRelatedToGastro = value;
    value = qs.acceptGsoc === 'true' ? true : qs.acceptgsoc;
    value = qs.acceptGsoc === 'false' ? false : undefined;
    this.dto.acceptGsoc = value;
    value = qs.acceptAgb === 'true' ? true : qs.acceptagb;
    value = qs.acceptAgb === 'false' ? false : undefined;
    this.dto.acceptAgb = value;
    value = qs.acceptFilledOutTruthful === 'true' ? true : qs.acceptfilledouttruthful;
    value = qs.acceptFilledOutTruthful === 'false' ? false : undefined;
    this.dto.acceptFilledOutTruthful = value;
    value = qs.acceptGsStatutes === 'true' ? true : qs.acceptgsstatutes;
    value = qs.acceptGsStatutes === 'false' ? false : undefined;
    this.dto.acceptGsStatutes = value;
    value = qs.newsletter === 'true' ? true : qs.newsletter;
    value = qs.newsletter === 'false' ? false : undefined;
    this.dto.newsletter = value;
    value = qs.acceptGdpr === 'true' ? true : qs.acceptgdpr;
    value = qs.acceptGdpr === 'false' ? false : undefined;
    this.dto.acceptGdpr = value;
    value = qs.acceptContactForClassification === 'true' ? true : qs.acceptcontactforclassification;
    value = qs.acceptContactForClassification === 'false' ? false : undefined;
    this.dto.acceptContactForClassification = value;
  }
}
